var popSignup = angular.module("pop.signup",[]);

popSignup.directive('popSignup', function(popSignup) {
	return {
		restrict: 'E',
		templateUrl: '/js/app/views/signup-directive.html',
		link: function(scope, el, attr) {
			el.addClass('pop-signup-portable');

			popSignup.init(scope, attr.open, attr.modal);
		}
	}
});

popDirectives.factory('popSignup', function($rootScope, $location, validationHelper, $anchorScroll, domainService, $route, $http){
	return {
		init: function(scope, openflag, modalflag) {
			var $scope = scope;
			var $nextbtn = $('#nextbutton'),
				$mainError = $('#main-error');

			$scope.steps = [
				'/register',
				'/register/userpass',
				'/register/contact',
				'/register/whois',
				'/register/payment',
				'/register/verify',
				'/register/complete'
			];

			$scope.slide = '';

			/**
			 * Run once on initialization.
			 */
			$rootScope.init = function() {
				var queryDomain = getQS('d');

				$rootScope.inModal = modalflag == 'true' ? true : false;
				$rootScope.currentStep = 0;
				
				$rootScope.showTitle = '';
				$rootScope.showSubtitle = '';

				$rootScope.formData = {};
				
				$rootScope.ajax = false;
				$rootScope.showAlerts = false;
				$rootScope.showSignup = false;

				$rootScope.showSignupForm = POP.showSignup;
				$rootScope.blockedIP = POP.blockedIP;

				$rootScope.suggestions = [];

				$rootScope.selectedDomain = null;
				$rootScope.selectedEmail = 'atmail';
				$rootScope.selectedStarterPage = null;

				// step validators
				$rootScope.domainError = false;
				$rootScope.domainErrors = false;
				$rootScope.validCustomFields = false;
				$rootScope.validEmailInfo = false;
				$rootScope.validCell = false;
				$rootScope.validEmail = false;
				$rootScope.validPin = false;
				$rootScope.validWhoisPhone = false;
				$rootScope.validWhois = false;
				$rootScope.validPayment = false;
				$rootScope.paymentSuccess = false;
				$rootScope.emailErrors = false;
				$rootScope.cellErrors = false;
				$rootScope.whoisPhoneErrors = false;

				$rootScope.currentBundle = 'myo';
				$rootScope.anytld = getTlds();

				// set form defaults
				$rootScope.formData.cell_countrycode = 'US';
				$rootScope.formData.cell_countrycode_numeric = 1;
				$rootScope.formData.whois_phone_countrycode = 'US';
				$rootScope.formData.whois_phone_countrycode_numeric = 1;
				$rootScope.formData.comm_pref = 'email';

				// check if query string ?d exists and turn on signup modal
				if (queryDomain) {
					$rootScope.checkForIpBlock();
					$rootScope.formData.domain = queryDomain === true ? "" : queryDomain;
				}
				
				if (parseInt(getQS('o')) === 1 && POP.showSignup != false) {
					$rootScope.toggleSignup(1, false);
				} else if (openflag === 'true') {
					$rootScope.toggleSignup('show');
				}
			}

			$rootScope.hasTldSelection = function() {
			 	return $rootScope.anytld && $rootScope.anytld != 'any';
			}

			$rootScope.clearTldSelection = function() {
			 	$rootScope.anytld = 'any';
			}

			$rootScope.setTldSelection = function() {
			 	// todo
			}

			$rootScope.checkForIpBlock = function(force) {
				if (POP.ipblocked === true || force === true) {
					window.location.href = '/notify';
				}

				return false;
			};

			/*
			 * Global method wrapper for domain registration validation. Note that if we aren't verifying,
			 * we're going straight to billing.
			 */
			$rootScope.validateVerify = function(verify_after_validation) {
				var bill_now = !verify_after_validation;

				$rootScope.showAlerts 		= false;
				$rootScope.formData.trial 	= false;

				// perform overall verification, if successful then route to verify
				validationHelper.validate($rootScope, bill_now).then(function(resp) {
					if (resp.code === 200) {
						if (verify_after_validation === true) {
							$location.url('/register/verify');
						} else {
							// trigger our payment success step
							$rootScope.paymentSuccess = true;
							$location.url('/register/complete');
						}
					} else {
						if (typeof resp.rules != 'undefined') {
							validationHelper.setFieldErrors(resp.rules, $rootScope, 'formPayment')
						}

						POP.Message.response($mainError, resp, false, false);
						$rootScope.showAlerts = true;
					}
				}).catch(function(e) {
					// display errors here
					void 0;

					POP.Message.response($mainError, { code: 500 }, false, false);
					$rootScope.showAlerts = true;
				});
			}

			/**
			 * Ensure our WHOIS data is validated. Call callback at the end.
			 */
			$rootScope.validateWhois = function() {
				$rootScope.ajax 		= true;
				$rootScope.showAlerts 	= false;

				// perform overall verification, if successful then route to verify
				validationHelper.validateWhois($rootScope).then(function(resp) {
					if (resp.code === 200) {
						$location.url('/register/payment');
					} else {
						if (typeof resp.rules != 'undefined') {
							validationHelper.setFieldErrors(resp.rules, $rootScope, 'formWhois')
						}

						POP.Message.response($mainError, resp, false, false);

						$rootScope.showAlerts = true;
					}
				}).catch(function(e) {
					// display errors here
					void 0;

					POP.Message.response($mainError, { code: 500 }, false, false);
					$rootScope.showAlerts = true;
				});
			}

			/**
			 * Handle validating the user's login name.
			 */
			$rootScope.validateEmail = function() {
				$rootScope.ajax = true;
				$rootScope.showAlerts = false;

				$http({
					method: 'POST',
					url: POP.apiBaseUrl + '/register/validate/login_name',
					data: JSON.stringify({email: $rootScope.formData.email}),
				}).success(function(resp){
					$rootScope.ajax = false;
					
					if (resp.code === 200) {
						$rootScope.trackNextStep('signup/userpass', 'signup/email', 'forward', 1, 2);
						$rootScope.nextStep();
					} else {
						if (typeof resp.rules != 'undefined') {
							validationHelper.setFieldErrors(resp.rules, $rootScope, 'formUser')
						}

						// show message
						POP.Message.response($mainError, resp, false, false);
						$rootScope.showAlerts = true;
					}
				}).error(function(response) {
					$scope.ajax = false;

					void 0;
					void 0;

					// track the funnel
					POP.trackFunnel('signup/validate-email-validation-failed');

					// show message
					POP.Message.response($mainError, { code: 500 }, false, false);
					$rootScope.showAlerts = true;
				});
			}

			/*
			 * Global method wrapper for registration pin validation service call.
			 */
			$rootScope.validatePin = function(redirect) {
				$rootScope.showAlerts = false;
				$rootScope.paymentSuccess = false;

				// check if the user is already verified
				if (redirect === true) {
					$rootScope.formData.already_verified = true;
				}

				validationHelper.validatePin($rootScope, false).then(function(resp) {
					if (resp.code != 200) {
						if (typeof resp.rules != 'undefined') {
							validationHelper.setFieldErrors(resp.rules, $rootScope, 'formVerify')
						}

						POP.Message.response($mainError, resp, false, false);
						$rootScope.showAlerts = true;
					} else {
						$rootScope.paymentSuccess = true;
						
						if (!redirect) {
							if ($rootScope.modalServiceSignup === true) {
								$rootScope.formData.tmp_user_id = resp.data.tmp_user_id;

								// straight to fake percolator
								$rootScope.validatePin(true);
							} else {
								$rootScope.formData.tmp_user_id = resp.data.tmp_user_id;
								$location.url('/register/complete');
							}
						}
					}
				});
			}

			/**
			 * Handle some basic coupon code validation.
			 */
			$rootScope.validateCouponCode = function(isCookie) {
				validationHelper.validateCouponCode($rootScope).then(function(resp) {
					if (resp.code != 200) {
						if (typeof resp.rules != 'undefined') {
							validationHelper.setFieldErrors(resp.rules, $rootScope, 'formPayment')
						}

						// unset invalid cookies so we dont hit this again
						if (isCookie === true) {
							$.removeCookie('coupon_code', { path: '/', domain: '.pop.co' });
						}

						POP.Message.response($mainError, resp, false, false);

						$rootScope.formData.promo_code = '';
						$rootScope.formData.coupon_code = '';

						$rootScope.showAlerts = true;
						$scope.couponCodeIsValid = false;
					} else {
						// update our messaging
						if (resp.msg) {
							$scope.validateCouponResponse = resp.msg;
						} else {
							$scope.validateCouponResponse = 'The coupon code you entered has been applied.';
						}

						// flag as successful
						$scope.showPromo = true;
						$scope.couponCodeIsValid = true;
						$rootScope.formData.coupon_code = $rootScope.formData.promo_code;
					}
				});
			}

			/**
			 * Condensed decision tree for picking the appropriate next step.
			 */
			$rootScope.triggerNextStep = function() {
				void 0;

				// if on /register
				if ($rootScope.currentStep == 0) {
					// todo: does this need to handle logged in states?
					$rootScope.trackNextStep('signup/domain', 'signup/userpass', 'forward', 0, 1);
					
				// if on /register/userpass
				} else if ($rootScope.currentStep == 1) {
					// validate login info before moving on
					$rootScope.validateEmail();
				// if on /register/contact
				} else if ($rootScope.currentStep == 2) {
					/*
					// we load the service custom fields
					if ($rootScope.modalServiceSignup === true) {
						// load custom service step
						$rootScope.trackNextStep('0-register', '1-customfields', 'forward');
					} else {
						// load default step: email
						$rootScope.trackNextStep('0-register', '1-email', 'forward');
						$rootScope.nextStep();
					}
					*/

					$rootScope.trackNextStep('signup/email', 'signup/whois', 'forward', 2, 3);
					$rootScope.nextStep();
					// if on /register/whois
				} else if ($rootScope.currentStep == 3) {
					$rootScope.trackNextStep('signup/whois', 'signup/payment', 'forward', 3, 4);
					$rootScope.validateWhois();
				// if on /register/payment
				} else if ($rootScope.currentStep == 4) {
					// jump straight to completed without verification
					$rootScope.trackNextStep('signup/payment', 'signup/complete', 'forward', 4, 5);
					$rootScope.validateVerify(false);
				// if on /register/verify
				} else if ($rootScope.currentStep == 5) {
					// trigger pin validation before proceeding
					$rootScope.trackNextStep('signup/verify', 'signup/complete', 'forward', 5, 6);
					$rootScope.validatePin();
				// if on /register/complete
				} else if ($rootScope.currentStep == 6) {
					$rootScope.trackNextStep('signup/complete', 'signup/percolate', 'forward', 6, 7);
					$rootScope.validatePin(true);
				}
			}

			/*
			 * Handles next step navigation, it contains a few logical checks i'd rather move somewhere else.
			 */
			$rootScope.nextStep = function(skip) {
				void 0;

				// check if the user's IP is blocked
				$rootScope.checkForIpBlock();

				// just in case its called directly
				if ($scope.isCurrentStepValid()) {
					void 0;

					/*
					// if this is part of an app store signup, we have some step overrides
					if ($rootScope.modalServiceSignup === true) && $rootScope.currentStep == 0) {
						$location.url('/register/service');
					} else if ($rootScope.modalServiceSignup === true) && $rootScope.currentStep == 1) {
						// handle validating our custom fields
						$scope.validateCustomFields();
					} else {
						console.log('Setting location: ' + $scope.steps[$rootScope.currentStep + 1]);

						// trigger update of view with url update
						$location.url($scope.steps[$rootScope.currentStep + 1]);
					}
					*/

					void 0;

					// trigger update of view with url update
					$location.url($scope.steps[$rootScope.currentStep + 1]);
				} else {
					void 0;
				}
			}

			/*
			 * Handles previous step navigation, contains some logical checks for registration method.
			 */
			$scope.prevStep = function() {
				$rootScope.checkForIpBlock();

				switch ($rootScope.currentStep) {
					// register
					case 0:
						$rootScope.trackNextStep('signup/register', 'signup/cancel', 'back', 0, -1);
						$rootScope.toggleSignup('hide', false);
						break;
					// userpass
					case 1:
						$rootScope.trackNextStep('signup/userpass', 'signup/register', 'back', 1, 0);
						$location.url('/register');
						break;
					// contact
					case 2:
						$rootScope.trackNextStep('signup/contact', 'signup/userpass', 'back', 1, 0);
						$location.url('/register/userpass');
						break;
					// whois
					case 3:
						$rootScope.trackNextStep('signup/whois', 'signup/contact', 'back', 2, 1);
						$location.url('/register/contact');
						/*
						if ($rootScope.modalServiceSignup === true) {
							$location.url('/register/userpass');
						} else {
							$location.url('/register/contact');
						}
						*/
						break;
					// payment
					case 4:
						$rootScope.trackNextStep('signup/payment', 'signup/whois', 'back', 3, 2);
						$location.url('/register/whois');
						break;
					// verify
					case 5:
						if ($rootScope.showResendMessage == true) {
							$rootScope.trackNextStep('signup/verify', 'signup/payment', 'back', 1, 0);
							$location.url('/register/payment');
						}
						break;
					// complete
					case 6:
						$rootScope.trackNextStep('signup/complete', 'signup/payment', 'back', 1, 0);
					default:
						$location.url($scope.steps[$rootScope.currentStep - 1]);
						break;
				}
			}

			/**
			 * Handle tracking our step progression for the user.
			 */
			$rootScope.trackNextStep = function(current, next, curIndex, nextIndex, direction) {
				void 0;
				
				// track our next step
				POP.trackFunnel(next);
			}

			/*
			 * Check if the current step passes it's validation method.
			 *
			 * TODO: refactor steps array to include each step's validation criteria
			 */
			$scope.isCurrentStepValid = function() {
				switch ($rootScope.currentStep) {
					// register - select domain
					case 0:
						return $rootScope.selectedDomain != null;
						break;
					// userpass
					case 1:
						return $rootScope.validUserPass;
						break;
					// new email address
					case 2:
						return $rootScope.validEmailInfo;
						/*
						// we load the service custom fields
						if ($rootScope.modalServiceSignup === true) {
							return $rootScope.validCustomFields;
						} else {
							return $rootScope.validEmailInfo;
						}
						*/
						break;
					// whois
					case 3:
						return $rootScope.validWhois;
						break;
					// payment
					case 4:
						return $rootScope.validPayment
							&& $rootScope.formData.confirm_terms == true;
					// verify comm pref
					case 5:
						return $rootScope.validPin;
						break;
					// complete
					case 6:
						return $rootScope.completeValid;
						break;
				}
			}

			$rootScope.resetSearch = function(option, wipeddmain) {
				$rootScope.showAlerts = false;
				$rootScope.suggestions = [];
				$rootScope.available = false;
				$rootScope.domainError = false;
				$rootScope.showSignup = true;
				$rootScope.selectedDomain = null;
				$rootScope.formData.domain = '';

				$location.hash('top');
				$anchorScroll();
				$location.url('/');
			}

			/*
			 * switch between signup modal / home content
			 */
			$rootScope.toggleSignup = function(option, wipedomain) {
				var queryDomain = getQS('d');
				var showRegister = wipedomain === false && (queryDomain != null && queryDomain.length > 0);

				if (option === 'notify') {
					$rootScope.checkForIpBlock(true);
					return;
				}

				$rootScope.showAlerts = false;
				$rootScope.suggestions = [];
				$rootScope.available = false;
				$rootScope.domainError = false;
				$rootScope.showSignup = $rootScope.showSignup === true ? false : true;
				$rootScope.selectedDomain = null;
				$rootScope.formData.domain = showRegister ? $rootScope.formData.domain : '';
				
				$location.hash('top');
				$anchorScroll();

				if (option === 'show') {
					$scope.showSignup = true;
					$location.url('/');
					return;
				} 

				if (option === 'hide') {
					$scope.showSignup = false;
					$location.url('/');
					$('footer').show();
					$('#nav-wrap').show();

					if (isMobile.any()) { 
						$('.main-site-header').show(); 
					}

					return;
				} 
				
				// hate to do this...  Also removing tab switcher when search is open.
				$('footer').toggle();
				$('#nav-wrap').toggle();
				
				if (isMobile.any()) { 
					$('.main-site-header').toggle(); 
				}

				// track this step event
				$rootScope.trackNextStep('signup', 'signup/register', 'forward', -1, 0);
				
				// pop open registration (todo: track this step?)
				$location.url($rootScope.showSignup ? '/register' : '/');
			}

			/*
			 * Global method for simple registration.
			 */
			$rootScope.simpleRegistration = function() {
				$rootScope.showAlerts = false;
				$rootScope.paymentSuccess = false;
				
				var data = {
					domain : '',
					firstname : '',
					lastname : '',
					comm_email : '',
					coupon_code : '',
					comm_pref : 'email',
					confirm_terms : 1,
					username : "empty"
				}

				domainService.simpleRegisterDomain(data);
			}

			/*
			 * utility method to find if this is a .co domain TODO: place this somewhere else
			 */
			$rootScope.isdotCo = function(domain) {
				if (typeof domain != 'undefined' && domain != null) {
					return domain.match(/\.co$/g) != null;
				}

				return false;
			}

			$rootScope.getStepText = function() {
				switch ($rootScope.currentStep) {
					// register
					case 0:
					// login
					case 1:
					// contact (new email)
					case 2:
					// whois
					case 3:
						return 'Next';
					// payment
					case 4:
						return 'Buy Now';
					case 5:
						return 'Verify';
					case 6:
						return 'Finish & Login';
					default:
						return 'Next';
				}
			}

			/**
			 * Every page can have a subtitle.
			 */
			$rootScope.getSubtitle = function() {
				var domains,
					st;

				if ($rootScope.anytld == 'any' || $rootScope.anytld === true || !$.isArray($rootScope.anytld)) {
					return 'Find your perfect domain name by entering keywords below.';
				}

				// sanitize domains
				domains = _.map($rootScope.anytld, function(tld) {
					return tld.toUpperCase().replace(/[^A-Z.]+/g, '');
				});

				domains = '<strong>.' + domains.join(', <strong>.') + '</strong>';
				st = 'Find your perfect ' + domains + ' domain by entering keywords below.';

				// match comma not followed by another comma
				return st.replace(/,(?![\s\S]*,)/g, ' or ');
			};

			/**
			 * Handle calculating the amount due.
			 */
			$rootScope.calculateAmountDue = function() {
				void 0;

				var amount = 0.00;

				if (!$rootScope.selectedDomain) {
					return amount;
				}

				// add to the price
				amount += parseFloat($rootScope.selectedDomain.price);

				void 0;
				void 0;
				void 0;

				// at a certain point we want access to the pricing
				if ($rootScope.modalServiceSignup) {
					if (typeof $rootScope.selectedPlan != 'undefined') {
						void 0;

						if ($rootScope.selectedPlan.plan_info.is_seated == 1) {
							amount += parseFloat($rootScope.selectedPlan.plan_info.amount_per_seat);
						} else {
							amount += parseFloat($rootScope.selectedPlan.plan_info.amount);
						}
					} else {
						void 0;
					}
				}

				void 0;

				return amount;
			}

			/**
			 * Calculate the domain price.
			 */
			$rootScope.calculateDomainPrice = function() {
				if (!$rootScope.selectedDomain) {
					return 'N/A';
				}

				return $rootScope.currentBundle == 'startup' ? '<span class="free">FREE</span>' : '$' + $rootScope.selectedDomain.price + '<small>/yr</small>';
			};

			/*
			 * routechangestart event listener, this is where we determine the 
			 * slide direction and change the class accordingly.
			 */
			$scope.$on('$routeChangeStart', function(e) {
				var path = $location.path(),
					next = $scope.steps.indexOf(path);

				$scope.slide = $rootScope.currentStep > next ? 'slide-right' : 'slide-left';

				// properly flag our current step change
				if (path == '/register/userpass') {
					$rootScope.currentStep = 1;
				} else {
					$rootScope.currentStep = next;
				}

				// track the funnel
                POP.trackFunnel(path);
			});

			/*
			 * viewcontentloaded event listener, we remove duplicate views, just in case.
			 */
			$scope.$on('$viewContentLoaded', function(e) {
				// Scroll viewcontainer to top if visible and step changed
				if ($('.viewcontainer').is(":visible")) {
					if (isMobile.any()) { 
						POP.scrollTo('.start-over-btn', true, false, 75);	
						// console.log('POP Scroll - mobile fired');	
					} else {
						POP.scrollTo('.start-over-btn', true, false, 200);	
						// console.log('POP Scroll - desktop fired');	
					}
				}
			});

			/*
			 * Hijack the enter key event to NOT submit the form.
			 */
			$('form').bind('keydown', function(evt) {
				var evt = (evt) ? evt : ((event) ? event : null);
				if (evt.keyCode == 13) {
					return false;
				}
			});

			// handle initializing our code
			$rootScope.init();
		}
	}
});
